/* Header links only. Native facets, product cards and availability remain unchanged. */
(() => {
  const header = document.querySelector('.tm-collection-hero');
  if (!header) return;
  const resultsTarget = header.dataset.resultsTarget || 'ResultsList';
  const budgetLinks = [...header.querySelectorAll('[data-budget-min]')];
  const brands = [...header.querySelectorAll('.tm-collection-brand')].map(link => ({
    link, values: [...new URL(link.href).searchParams.entries()].filter(([key]) => key === 'filter.p.vendor')
  }));
  const amount = value => {
    if (!value) return null;
    return Number(value.includes(',') ? value.replaceAll('.', '').replace(',', '.') : value);
  };
  const sync = () => {
    const current = new URL(location.href);
    budgetLinks.forEach(link => {
      const url = new URL(current);
      url.searchParams.delete('page');
      ['gte', 'lte'].forEach((suffix, i) => {
        const value = i ? link.dataset.budgetMax : link.dataset.budgetMin;
        const name = 'filter.v.price.' + suffix;
        value ? url.searchParams.set(name, value) : url.searchParams.delete(name);
      });
      url.hash = resultsTarget;
      link.href = url.href;
      const active = (amount(current.searchParams.get('filter.v.price.gte')) || 0) === (amount(link.dataset.budgetMin) || 0)
        && amount(current.searchParams.get('filter.v.price.lte')) === amount(link.dataset.budgetMax);
      active ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current');
    });
    brands.forEach(({link, values}) => {
      if (!values.length) return;
      const url = new URL(current);
      const active = values.every(([key, value]) => current.searchParams.getAll(key).includes(value));
      const keys = new Set(values.map(([key]) => key));
      keys.forEach(key => url.searchParams.delete(key));
      if (!active) values.forEach(([key, value]) => url.searchParams.append(key, value));
      url.searchParams.delete('page');
      url.hash = resultsTarget;
      link.href = url.href;
      link.classList.toggle('is-active', active);
      active ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current');
    });
  };
  if (header.dataset.budgetMode === 'offers') {
    header.addEventListener('click', event => {
      const link = event.target.closest('[data-budget-min]');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.pushState(null, '', link.href);
      sync();
      document.dispatchEvent(new Event('tm:budget-change'));
      document.getElementById(resultsTarget)?.scrollIntoView({block:'start',behavior:'instant'});
    });
  }
  sync();
  header.addEventListener('pointerdown', sync);
  header.addEventListener('focusin', sync);
  window.addEventListener('popstate', sync);
  const results = document.querySelector('results-list');
  if (results) new MutationObserver(sync).observe(results, {childList:true, subtree:true});

  // Pause the native infinite-scroll observer only while reading the guide.
  // Its public observer and refs are supplied by the existing PaginatedList component.
  const guide = document.getElementById('tm-gravel-guide');
  const help = header.querySelector('a[href="#tm-gravel-guide"]');
  if (!guide || !help || !results) return;
  let readingGuide = false;
  let readingTop = 0;
  let resizeObserver;
  let lastUserScroll = 0;
  const markUserScroll = () => { lastUserScroll = Date.now(); };
  window.addEventListener('wheel', markUserScroll, {passive:true});
  window.addEventListener('touchmove', markUserScroll, {passive:true});
  window.addEventListener('keydown', event => {
    if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key)) markUserScroll();
  });
  const resumeProducts = () => {
    if (!readingGuide) return;
    readingGuide = false;
    resizeObserver?.disconnect();
    const observer = results.infinityScrollObserver;
    const refs = results.refs;
    if (observer && refs) {
      if (refs.viewMorePrevious) observer.observe(refs.viewMorePrevious);
      if (refs.viewMoreNext) observer.observe(refs.viewMoreNext);
    }
  };
  const alignAfterLoad = () => {
    if (!readingGuide) return;
    const drift = guide.getBoundingClientRect().top - readingTop;
    if (Math.abs(drift) > 1) window.scrollBy({top:drift, behavior:'instant'});
    readingTop = guide.getBoundingClientRect().top;
  };
  const openGuide = event => {
    if (event && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    event?.preventDefault();
    results.infinityScrollObserver?.disconnect();
    readingGuide = true;
    resizeObserver?.disconnect();
    if (location.hash !== '#tm-gravel-guide') {
      const url = new URL(location.href);
      url.hash = 'tm-gravel-guide';
      history.pushState(null, '', url);
    }
    guide.setAttribute('tabindex', '-1');
    guide.focus({preventScroll:true});
    guide.scrollIntoView({block:'start', behavior:'instant'});
    readingTop = guide.getBoundingClientRect().top;
    resizeObserver = new ResizeObserver(alignAfterLoad);
    resizeObserver.observe(results);
  };
  help.addEventListener('click', openGuide);
  window.addEventListener('scroll', () => {
    if (!readingGuide || Date.now() - lastUserScroll > 500) return;
    const top = guide.getBoundingClientRect().top;
    if (top > window.innerHeight * 0.75) resumeProducts();
    else readingTop = top;
  }, {passive:true});
  window.addEventListener('popstate', resumeProducts);
  if (location.hash === '#tm-gravel-guide') {
    customElements.whenDefined('results-list').then(() => openGuide());
  }
})();
